import React, { useState } from 'react';
import './ActionMenu.css';

const ActionMenu = ({ menuConfig, disabled }) => {
    // První kategorie je aktivní ve výchozím stavu
    const [activeCategory, setActiveCategory] = useState(menuConfig[0].label);

    const activeSubItems = menuConfig.find(cat => cat.label === activeCategory)?.subItems || [];

    return (
        <div className={`action-menu-wrapper ${disabled ? 'disabled' : ''}`}>
            <div className="action-menu-categories">
                {menuConfig.map(category => (
                    <div
                        key={category.label}
                        className={`category-item ${activeCategory === category.label ? 'active' : ''}`}
                        onMouseEnter={() => setActiveCategory(category.label)} // Změna už při najetí myší
                    >
                        {category.label}
                    </div>
                ))}
            </div>
            <div className="action-menu-subitems">
                {activeSubItems.map(subItem => (
                    <div
                        key={subItem.label}
                        className="subitem"
                        onClick={!disabled ? subItem.onClick : undefined}
                    >
                        {subItem.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ActionMenu;